import React from "react";

import Drawer from "material-ui/Drawer";
import List from "material-ui/List";
import Divider from "material-ui/Divider";

import "./TemporaryDrawer.css";
//import { mailFolderListItems, otherMailFolderListItems } from "./tileData";

import { ListItem, ListItemIcon, ListItemText } from "material-ui/List";

import PersonIcon from "material-ui-icons/Person";
import HomeIcon from "material-ui-icons/Home";
import DashboardIcon from "material-ui-icons/Dashboard";
import LocalGasStationIcon from "material-ui-icons/LocalGasStation";
import LocalShippingIcon from "material-ui-icons/LocalShipping";
import BeenHereIcon from "material-ui-icons/Beenhere";
import ACUnitIcon from "material-ui-icons/AcUnit";
import Memory from "material-ui-icons/Memory";
import AlbumIcon from "material-ui-icons/Album";

import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { openDrawer, closeDrawer } from "../../modules/navigation";

class TemporaryDrawer extends React.Component {
  render() {
    const { permissions } = this.props;
    return (
      <Drawer
        open={this.props.isDrawerOpen}
        onClose={this.props.closeDrawer}
        className="temporary-drawer"
      >
        <div
          tabIndex={0}
          role="button"
          onClick={this.props.closeDrawer}
          onKeyDown={this.props.closeDrawer}
        >
          <div className="list">
            <List>
              <ListItem button className="user-item">
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary={this.props.user.NombreUsuario} />
              </ListItem>

              <Divider />

              <ListItem button onClick={this.props.changePage.bind(this, "./")}>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary={this.props.lang.InicioHome} />
              </ListItem>

              <ListItem
                disabled={!permissions.Dashboard}
                button
                onClick={this.props.changePage.bind(this, "./dashboard")}
              >
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>

              <ListItem
                disabled={!permissions.Fuel}
                button
                onClick={this.props.changePage.bind(this, "./fuel")}
              >
                <ListItemIcon>
                  <LocalGasStationIcon />
                </ListItemIcon>
                <ListItemText primary="Fuel" />
              </ListItem>

              <ListItem
                disabled={!permissions.Gas}
                button
                onClick={this.props.changePage.bind(this, "./gas")}
              >
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText primary="Gas" />
              </ListItem>

              <ListItem
                disabled={!permissions.Driving}
                button
                onClick={this.props.changePage.bind(this, "./driving")}
              >
                <ListItemIcon>
                  <BeenHereIcon />
                </ListItemIcon>
                <ListItemText primary="Driving" />
              </ListItem>

              <ListItem
                disabled={!permissions.ConsultaTemp}
                button
                onClick={this.props.changePage.bind(this, "./temp")}
              >
                <ListItemIcon>
                  <ACUnitIcon />
                </ListItemIcon>
                <ListItemText primary="Temp" />
              </ListItem>

              <ListItem
                disabled={!permissions.ConsultaCan}
                button
                onClick={this.props.changePage.bind(this, "./scan")}
              >
                <ListItemIcon>
                  <Memory />
                </ListItemIcon>
                <ListItemText primary="Scan" />
              </ListItem>

              {/* <ListItem
                disabled={false}
                button
                onClick={this.props.changePage.bind(this, "./llantaspro")}
              >
                <ListItemIcon>
                  <AlbumIcon />
                </ListItemIcon>
                <ListItemText primary="LlantasPro" />
              </ListItem> */}
            </List>
          </div>
        </div>
      </Drawer>
    );
  }
}

const mapStateToProps = state => ({
  isDrawerOpen: state.navigation.isDrawerOpen,
  lang: state.internationalization.lang,
  permissions: state.permissions.data,
  user: state.user.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openDrawer,
      closeDrawer,
      changePage: page => push(page)
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemporaryDrawer);



// WEBPACK FOOTER //
// ./src/containers/TemporaryDrawer/TemporaryDrawer.js